export const cOrder = {
    default: 0,
    asc: 1,
    desc: 2
}